import { openBlock as o, createElementBlock as t, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, r = /* @__PURE__ */ e("g", { "clip-path": "url(#person_svg__a)" }, [
  /* @__PURE__ */ e("path", {
    fill: "currentColor",
    d: "M13.657 10.343a8 8 0 0 0-3.04-1.907 4.62 4.62 0 0 0 2.008-3.811A4.63 4.63 0 0 0 8 0a4.63 4.63 0 0 0-4.625 4.625c0 1.58.796 2.977 2.008 3.811a8 8 0 0 0-3.04 1.907A7.95 7.95 0 0 0 0 16h1.25A6.76 6.76 0 0 1 8 9.25 6.76 6.76 0 0 1 14.75 16H16a7.95 7.95 0 0 0-2.343-5.657M8 8a3.38 3.38 0 0 1-3.375-3.375A3.38 3.38 0 0 1 8 1.25a3.38 3.38 0 0 1 3.375 3.375A3.38 3.38 0 0 1 8 8"
  })
], -1), l = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "person_svg__a" }, [
    /* @__PURE__ */ e("path", {
      fill: "currentColor",
      d: "M0 0h16v16H0z"
    })
  ])
], -1), s = [
  r,
  l
];
function c(a, _) {
  return o(), t("svg", n, [...s]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
